<script setup lang="ts">
import { sendFileCreateRequest } from "~/classes/handlers/file/create"

const { parsePastedUrl } = useClipboard()
const { currentRootFolder } = useNavigation()
const { notifyError } = useAlerts()
const { hideContextMenu } = useContextMenu()

const url = ref("")

async function addLink() {
  console.debug("User added a url", url.value)
  const destination = currentRootFolder.value
  if (!destination)
    return console.error("No destination folder")
  try {
    const { file, preHash } = await parsePastedUrl(url.value, destination)
    sendFileCreateRequest({
      requestId: generateWorkerRequestId(),
      file: file.inner(),
      offline: false,
      preHash,
    })
    hideContextMenu()
  }
  catch (error) {
    notifyError("Unable to create link", (error as Error).message)
  }
}
</script>

<template>
  <dropdown-sub-view class="add-link">
    <div>
      <dropdown-text-input
        v-model="url"
        placeholder="Paste URL here..."
        @submit="() => addLink()"
      />
    </div>
  </dropdown-sub-view>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.add-link
  @apply w-80
</style>
